import { render, staticRenderFns } from "./DashboardEstimage.vue?vue&type=template&id=6161e778&scoped=true"
import script from "./DashboardEstimage.vue?vue&type=script&lang=js"
export * from "./DashboardEstimage.vue?vue&type=script&lang=js"
import style0 from "./DashboardEstimage.vue?vue&type=style&index=0&id=6161e778&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6161e778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6161e778')) {
      api.createRecord('6161e778', component.options)
    } else {
      api.reload('6161e778', component.options)
    }
    module.hot.accept("./DashboardEstimage.vue?vue&type=template&id=6161e778&scoped=true", function () {
      api.rerender('6161e778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardEstimage.vue"
export default component.exports